module.exports = __webpack_public_path__ + "img/kids-start.c456e8d4.png";